export default __webpack_public_path__ + "static/media/everyoneskate.1970f664.jpeg";